import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { SelectListItemDto, UserPermissionServiceProxy, WarehouseSelectListDto } from '../../../../../../../../../shared/service-proxies/service-proxies';
import { TestService } from 'test/service/test.service';
import { CustomLocalizationService } from '@app/views/pages/transpop/utility/customLocalization.service';

@Component({
  selector: 'kt-from-receive-mobil-warehouse',
  templateUrl: './from-receive-mobil-warehouse.component.html',
  styleUrls: ['./from-receive-mobil-warehouse.component.scss']
})
export class FromReceiveMobilWarehouseComponent implements OnInit, OnDestroy {
	
  //Dynamic componentin basıldığı yere data göndermemizi sağlar.
  //Yani bu componentten başka bir componente burada ki datayı gönderiyoruz.
  dynamicComponentObject  = new Subject();

  //Combobox içerisinde seçilen mobil warehouse ngModel ile yakalatız
  //Teslim alınacak mobil depolar demektir.
  selectedMobilWarehouse = new WarehouseSelectListDto();

  //Combobox içerisine doldurulacak olan mobil warehouse listesini tutar.
	mobilWarehouses = new BehaviorSubject<WarehouseSelectListDto[]>([]);


	constructor(private _userPermissionService: UserPermissionServiceProxy,
		private _testService: TestService,
		private customLocalization: CustomLocalizationService) { }
  
  ngOnInit() {

	  this._testService.setTitle(this.customLocalization.l("FE.PAGEHEADERS.ORDER.FROMRECEIVEWAREHOUSE.FROMRECEIVEMOBILEWAREHOUSE.HEADER"));
	  this._testService.setDesc(this.customLocalization.l("FE.PAGEHEADERS.ORDER.FROMRECEIVEWAREHOUSE.FROMRECEIVEMOBILEWAREHOUSE.SUBHEADER"));


	  //Kullanıcı bazlı olarak mobil WareHouse listesini bize verir.
	  this._userPermissionService.getFromReceiveMobileWarehoseByUserAuths().subscribe((wareHouses: WarehouseSelectListDto[]) => {

		  this.mobilWarehouses.next(wareHouses);
    })

  }

 
  //Combobox içerisinde ki herhangi bir değişimi yakaladığımız methoddur.
	//ve bu methıd sayesinde her değişiklik olduğunda yeni seçilen datayı dynamic
	//componentin olduğu component içerisine atabiliyoruz.
	//mesela: kullanıcı deposunu değiştirdi anlık olarak bu methodla yayınlayının içerisine yeni datayı atıyoruz.
	//ve step3 içerisinde ki dynamic data üretici methodun subscribe içerisinde yakalıyoruz.
  onChangeMobilWareHouse(){
	  
	  this.dynamicComponentObject.next(this.selectedMobilWarehouse);
  }

	ngOnDestroy() {

		this._testService.setTitle(" ");
		this._testService.setDesc(" ");

		this.dynamicComponentObject.unsubscribe();
		this.mobilWarehouses.unsubscribe();

	}
}
